module.exports = "<ng-container *ngIf=\"details && css\">\n    <div [class]=\"css.wrapper\">\n        <div *ngFor=\"let detail of details\" [class]=\"css.item + ' presentation-item'\">\n            <div class=\"col-xs-6\">\n                {{detail.label}}\n            </div>\n            <div class=\"col-xs-6\">\n                {{detail.value}}\n            </div>\n        </div>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/shared/presentation/presentation.component.html
// module id = ../../../../../src/app/shared/presentation/presentation.component.html
// module chunks = main